import { useEffect, useState } from 'react';
import { apiFetch } from '../config/api';

export default function ResetPassword({ onBack, initialCode = '' }) {
  const codeFromUrl = (initialCode || '').trim().toUpperCase();
  const hasCodeFromUrl = Boolean(codeFromUrl);
  const [code, setCode] = useState(codeFromUrl);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setCode(codeFromUrl);
  }, [codeFromUrl]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!code.trim()) { setError('Please enter your reset code.'); return; }
    if (newPassword.length < 6) { setError('Password must be at least 6 characters.'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match.'); return; }

    setLoading(true);
    try {
      await apiFetch('/password-resets/reset', {
        method: 'POST',
        body: JSON.stringify({ code: code.trim().toUpperCase(), new_password: newPassword }),
      });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sa-login-page">
      <div className="sa-login-card">
        {done ? (
          <>
            <h1>Password Set!</h1>
            <p>Your password has been updated. You can now log in.</p>
            <button className="sa-btn sa-btn-primary" style={{ width: '100%' }} onClick={onBack}>
              Back to Login
            </button>
          </>
        ) : (
          <>
            <h1>Reset Password</h1>
            <p>You're almost done. Choose a new password for your account.</p>

            {error && <div className="sa-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              {hasCodeFromUrl ? (
                <details className="sa-reset-code-details">
                  <summary>Reset code loaded from link</summary>
                  <div className="sa-field">
                    <label>Reset Code</label>
                    <input
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      placeholder="e.g. K7HN3P"
                      maxLength={6}
                      style={{ textTransform: 'uppercase', letterSpacing: 3, fontWeight: 700 }}
                      required
                    />
                  </div>
                </details>
              ) : (
                <div className="sa-field">
                  <label>Reset Code</label>
                  <input
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="e.g. K7HN3P"
                    maxLength={6}
                    style={{ textTransform: 'uppercase', letterSpacing: 3, fontWeight: 700 }}
                    required
                    autoFocus
                  />
                </div>
              )}
              <div className="sa-field">
                <label>New Password</label>
                <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required autoFocus={hasCodeFromUrl} />
              </div>
              <div className="sa-field">
                <label>Confirm Password</label>
                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
              </div>
              <button type="submit" className="sa-btn sa-btn-primary" style={{ width: '100%', marginTop: 8 }} disabled={loading}>
                {loading ? 'Resetting password...' : 'Reset Password'}
              </button>
            </form>

            <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: '#666' }}>
              <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#4a90d9', textDecoration: 'underline', fontSize: 13, padding: 0 }}>
                Back to Login
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
